export default "__VITE_ASSET__CQVVsB7Q__"